import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { charactersState } from '../../../types/script';
import { getCharactersByScriptId } from 'src/app/db/queries';

//Fetch a la API de Characters

const initialState: charactersState = {
    characters: [],
    isLoading: false,
    error: null,
};

export const fetchCharacters = createAsyncThunk(
    'scriptList/fetchCharacters',
    async ({ scriptId}: { scriptId: string }, { rejectWithValue }) => {
        try {
            const data = await getCharactersByScriptId(scriptId);
            //console.log("Fetching characters for:", scriptId);
            return { data };
        } catch (error: any) {
            console.error('Unexpected error in fetchScripts:', error);
            return rejectWithValue(error.message); 
        }
    }
);


export const scriptCharactersSlice = createSlice({
    name: 'scriptList',
    initialState,
    reducers: {
        clearCharactersList: (state) => {
            state.characters = [];
            state.isLoading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCharacters.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchCharacters.fulfilled, (state, action) => {
                state.isLoading = false;
                state.characters = action.payload.data;
            })
            .addCase(fetchCharacters.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearCharactersList } = scriptCharactersSlice.actions;
export const scriptsCharactersReducer = scriptCharactersSlice.reducer;
